export default "<ng-container>{{ _data }}</ng-container>\r\n";